export default __webpack_public_path__ + "static/assets/med_pill_square_in_L2_solid_l_01_f.5edb5cdb.png";